<aside class="sidebar" [class.fixed]="fixed" [class.minimized]="minimized" [class.show]="show">
  <ng-content></ng-content>
</aside>
